import ProvidersList from './ProvidersList';

export default function Seguro() {
    return (
        <ProvidersList
            type="seguro"
            title="Seguro"
            subtitle="Benefícios de seguro dos assinantes."
        />
    );
}
